import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { StoreError } from '~/common/model'
import {
  Discount,
  ErrorResponseDiscount,
  ResponseDiscount,
  FetchDiscountRequest,
} from '~/discounts/model/discount.model'

export type DiscountState = {
  loading: boolean
  error?: StoreError
  data?: Discount[]
}

export type DiscountsState = {
  [key: string]: DiscountState
}

export const initialStateEle: DiscountState = {
  loading: false,
  error: undefined,
  data: undefined,
}
export const initialState = {}

export const discountSlice = createSlice({
  name: 'discount',
  initialState: {} as DiscountsState,
  reducers: {
    fetchDiscount: (_state, action: PayloadAction<FetchDiscountRequest>) => {
      const {
        payload: { subscriptionId },
      } = action
      return { ..._state, [subscriptionId || '']: { ...initialStateEle, loading: true } }
    },
    fetchDiscountSuccess(_state, action: PayloadAction<ResponseDiscount>) {
      const { payload } = action
      return {
        ..._state,
        [payload.subscriptionId]: { ...initialStateEle, data: payload.discount.items },
      }
    },
    fetchDiscountError(_state, action: PayloadAction<ErrorResponseDiscount>) {
      const { payload } = action
      return { ..._state, [payload.subscriptionId]: { ...initialStateEle, error: payload.error } }
    },
  },
})

export const { fetchDiscount, fetchDiscountSuccess, fetchDiscountError } = discountSlice.actions

const discountReducer = discountSlice.reducer
export default discountReducer
